import axiosClient from "./axiosClient";

export const getCauseTypes = async (teamId) => {
  console.log("send teamId:", teamId);

  const response = await axiosClient.get(
    `/causetype/${encodeURIComponent(teamId)}`
  );

  console.log("got " + JSON.stringify(response.data));
  return response.data;
};
